/* Marcel Afters, PDP-GENDER (25 Sep 2026): client side of the COLOUR x GENDER gallery (snippets/ma-cg.liquid).
   The server renders the right set whenever the URL carries a gendered collection. This file only covers what the
   server can't know: the audience remembered from an earlier page (sessionStorage ma_g), the 'Shown on' toggle,
   the default colour on first load, and a preload of the next colour's first image on swatch hover.
   A context change re-asks the server for the gallery through the product's own collection URL, so every rule
   stays in one place (Liquid) and Horizon's variant re-render keeps the context. */
(function () {
  'use strict';

  var KEY = 'ma_g';
  var LETTER = { her: 'h', him: 'm', unisex: 'u' };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var override = null;
  var seen = {};
  var userPicked = false;
  var syncing = false;

  function gallery() {
    return [].filter.call(document.querySelectorAll('media-gallery[data-ma-cg]'), function (g) {
      return !g.closest('product-card, dialog:not(.dialog-zoomed-gallery__dialog)');
    })[0] || null;
  }

  function cfg() {
    var g = gallery();
    var n = g && g.querySelector('script[data-ma-cg-cfg]');
    if (!n) return null;
    try { return JSON.parse(n.textContent); } catch (e) { return null; }
  }

  function store(k, v) { try { if (v) sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  function mainPickers() {
    return [].filter.call(document.querySelectorAll('variant-picker'), function (p) {
      return !p.closest('product-card, dialog, .ma-ctl, quick-add-component');
    });
  }

  function colourInputs() {
    var out = [];
    mainPickers().forEach(function (p) {
      [].forEach.call(p.querySelectorAll('input[type="radio"]'), function (i) {
        if (/^colou?r$/i.test(i.getAttribute('data-option-name') || '')) out.push(i);
      });
    });
    return out;
  }

  /* Horizon re-renders the gallery from the picker's data-product-url; keep it on the chosen context's URL. */
  function applyOverride() {
    if (!override) return;
    mainPickers().forEach(function (p) {
      var u = (p.getAttribute('data-product-url') || '').split('?')[0];
      if (u !== override) p.setAttribute('data-product-url', override);
    });
  }
  new MutationObserver(applyOverride).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['data-product-url']
  });

  function variantId() {
    return new URL(location.href).searchParams.get('variant');
  }

  function swap(want) {
    var c = cfg();
    var g = gallery();
    if (!c || !g || !c.hc) return Promise.resolve(false);
    var path;
    if (c.hc[want]) path = root + 'collections/' + c.hc[want] + '/products/' + c.handle;
    else if (want === 'unisex' && c.tog.indexOf('u') > -1) path = root + 'products/' + c.handle;
    else return Promise.resolve(false);
    var section = g.closest('.shopify-section');
    if (!section) return Promise.resolve(false);
    var q = '?section_id=' + encodeURIComponent(section.id.replace(/^shopify-section-/, ''));
    var here = new URL(location.href).searchParams;
    var v = userPicked ? here.get('variant') : null;
    if (v) q += '&variant=' + encodeURIComponent(v);
    if (here.get('view')) q += '&view=' + encodeURIComponent(here.get('view'));
    g.setAttribute('aria-busy', 'true');
    return fetch(path + q, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok || r.redirected) throw new Error('context url');
        return r.text();
      })
      .then(function (t) {
        var fresh = new DOMParser().parseFromString(t, 'text/html').querySelector('media-gallery');
        if (!fresh) throw new Error('no gallery');
        var cur = gallery();
        if (cur) cur.replaceWith(fresh);
        override = path;
        applyOverride();
        var u = new URL(location.href);
        u.pathname = path;
        if (!v) u.searchParams.delete('variant');
        history.replaceState(history.state, '', u.toString());
        return true;
      })
      .catch(function () {
        var cur = gallery();
        if (cur) cur.removeAttribute('aria-busy');
        return false;
      });
  }

  /* Without a colour the shopper chose, the gallery leads with the context's default colour, so the picker follows it. */
  function syncColour() {
    if (userPicked || variantId()) return;
    var c = cfg();
    if (!c || !c.sel) return;
    var ins = colourInputs();
    var on = ins.filter(function (i) { return i.checked; })[0];
    if (on && on.value === c.sel) return;
    var t = ins.filter(function (i) { return i.value === c.sel; })[0];
    if (!t) return;
    syncing = true;
    t.click();
    syncing = false;
  }

  function preload(input) {
    var c = cfg();
    var url = c && c.leads && c.leads[input.value];
    if (!url || seen[url]) return;
    seen[url] = true;
    var g = gallery();
    var img = g && g.querySelector('.product-media img');
    var m = img && /[?&]width=(\d+)/.exec(img.currentSrc || '');
    var w = m ? m[1] : '1200';
    var pre = new Image();
    pre.decoding = 'async';
    pre.src = url.replace(/([?&])width=\d+/, '$1width=' + w);
  }

  function inputFrom(target) {
    var label = target && target.closest && target.closest('label');
    var input = label && label.querySelector('input[type="radio"]');
    return input && colourInputs().indexOf(input) > -1 ? input : null;
  }

  document.addEventListener('pointerover', function (e) {
    var i = inputFrom(e.target);
    if (i) preload(i);
  });
  document.addEventListener('pointerdown', function (e) {
    var i = inputFrom(e.target);
    if (i) preload(i);
  });
  document.addEventListener('focusin', function (e) {
    if (colourInputs().indexOf(e.target) > -1) preload(e.target);
  });

  document.addEventListener('change', function (e) {
    if (!syncing && colourInputs().indexOf(e.target) > -1) userPicked = true;
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ma-cg-g]');
    if (!b || b.getAttribute('aria-pressed') === 'true') return;
    var want = b.getAttribute('data-ma-cg-g');
    store(KEY, want);
    swap(want).then(function (ok) { if (ok) syncColour(); });
  });

  function init() {
    var c = cfg();
    if (!c) return;
    var step = Promise.resolve(false);
    if (c.src === 'coll') {
      store(KEY, c.ctx);
    } else if (c.src === 'def') {
      var want = read(KEY) || read('ma_side');
      if (want && want !== c.ctx && c.tog && c.tog.indexOf(LETTER[want]) > -1 && c.hc && c.hc[want]) step = swap(want);
    }
    step.then(syncColour);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
